import React from 'react'

import { DefaultMediaWizardLayout } from './DefaultMediaWizardLayout'

import { Sponsorships as SponsorshipsComponent } from 'components/Sponsorships'
import { Breadcrumb } from 'components/Links'

import { useDocumentTitle } from '@percept/hooks'


const breadcrumbs: Breadcrumb[] = [
  {
    path: '/wizard/optimisation',
    name: 'Optimisation',
  },
  {
    path: '/wizard/optimisation/sponsorships',
    name: 'Sponsorships',
  },
]


export const Sponsorships = (): JSX.Element => {
  useDocumentTitle({ paths: ['Optimisation', 'Sponsorships'] })
  return (
    <DefaultMediaWizardLayout
      breadcrumbs={breadcrumbs}>

      <SponsorshipsComponent />

    </DefaultMediaWizardLayout>
  )
}
